module.exports = __webpack_public_path__ + "fonts/ttnorms-thin-webfont.e3a7f434.woff";